import { render, staticRenderFns } from "./contractSideView.vue?vue&type=template&id=60284556"
import script from "./contractSideView.vue?vue&type=script&lang=js"
export * from "./contractSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports